import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Feature } from './feature'
import type * as models from './models'
import type { State } from './state'

/**
 * Core actions for this {@link Feature}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Retrieves the current user info
     */
    get: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<models.User>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          user: { isLoading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          user: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          user: { error },
        }),
        cancellation: ({ state }) => ({
          ...state,
          user: undefined,
        }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
